import { makeStyles } from '@mui/styles'

export default makeStyles(() => ({
  root: {
    width: '100%',
  },
  sectionTitle: {
    marginBottom: 12,
  },
  fields: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
    gap: '0 20px',
    margin: 0,
  },
  field: {
    minWidth: 0,
    padding: '8px 0',
    borderBottom: '1px solid #e0e0e0',
    '& dt': {
      color: '#616161',
      fontSize: '1rem',
      fontWeight: 600,
    },
    '& dd': {
      margin: '3px 0 0',
      overflowWrap: 'anywhere',
      fontSize: '1.2rem',
    },
  },
  loading: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    verticalAlign: 'middle',
    flexDirection: 'column',
    gap: 12,
    minHeight: 180,
  },
  json: {
    maxHeight: '52vh',
    overflow: 'auto',
    margin: 0,
    padding: 16,
    borderRadius: 4,
    backgroundColor: '#202124',
    color: '#e8eaed',
    fontFamily: 'Consolas, "Liberation Mono", monospace',
    fontSize: '1.2rem',
    lineHeight: 1.5,
    whiteSpace: 'pre',
  },
  jsonContainer: {
    position: 'relative',
  },
  expandButton: {
    position: 'absolute',
    top: 8,
    right: 24,
    zIndex: 1,
    color: '#e8eaed',
    backgroundColor: 'rgba(95, 93, 93, 0.85)',
    '&:hover': {
      backgroundColor: 'rgba(60, 64, 67, 0.95)',
    },
  },
  expandedDialogContent: {
    position: 'relative',
    display: 'flex',
    overflow: 'hidden',
    padding: '24px !important',
    backgroundColor: '#202124',
  },
  expandedJson: {
    width: '100%',
    height: '100%',
    overflow: 'auto',
    margin: 0,
    padding: '32px 16px 16px',
    color: '#e8eaed',
    fontFamily: 'Consolas, "Liberation Mono", monospace',
    fontSize: '1.2rem',
    lineHeight: 1.6,
    whiteSpace: 'pre',
  },
  closeExpandedButton: {
    position: 'absolute',
    top: 12,
    right: 12,
    zIndex: 1,
    color: '#e8eaed',
    backgroundColor: 'rgba(32, 33, 36, 0.85)',
    '&:hover': {
      backgroundColor: 'rgba(60, 64, 67, 0.95)',
    },
  },
}))
